import { render, staticRenderFns } from "./TrainingRecords.vue?vue&type=template&id=56150554&scoped=true"
import script from "./TrainingRecords.vue?vue&type=script&lang=js"
export * from "./TrainingRecords.vue?vue&type=script&lang=js"
import style0 from "./TrainingRecords.vue?vue&type=style&index=0&id=56150554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56150554",
  null
  
)

export default component.exports